import GoogleMapsProvider from "./GoogleMapsProvider"

export { GoogleMapsProvider }
export default GoogleMapsProvider
